import {Component, OnInit, Input} from '@angular/core';
import {ActivatedRoute, RouterLink} from '@angular/router';

import {AuthenticatorService} from '../../common/service/authenticator.service';
import {UserPreferencesModalService} from '../../common/component/modal';
import {NAV_MENUS} from '../../common/constants';
import {HamburgerService} from '../hamburger/hamburger.service';
import {PermissionsService} from '../../common/service/permissions.service';
import {NavigationService} from '../../common/service/navigation.service';

@Component({
    selector: 'nlr-header',
    imports: [RouterLink],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
    @Input()
    menuItem: string;

    enableHeaderItems: boolean = false;
    enableHomeItem: boolean = false;

    editDesignPreferencesPermissions = ['EDIT_DESIGN_PREFERENCES'];

    mydashboardTitle: string = 'My dashboard is a workspace for plan management';
    actionItemsTitle: string = 'View the actions menu';

    constructor(
        private authenticatorService: AuthenticatorService,
        private userPreferencesModalService: UserPreferencesModalService,
        private hamburgerService: HamburgerService,
        private permissionsService: PermissionsService,
        private navigationService: NavigationService,
        private activatedRoute: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.enableHeaderItems = this.menuItem === NAV_MENUS.PLAN_DETAIL;
        this.enableHomeItem = this.menuItem !== NAV_MENUS.HOME;
    }

    getUserName() {
        return this.authenticatorService.getUsername();
    }

    getUserDisplayName() {
        return this.authenticatorService.getDisplayName();
    }

    toggleHamburgerVisibility() {
        if (this.hamburgerService.isHamburgerVisible()) {
            this.hamburgerService.hideHamburger();
        } else {
            this.hamburgerService.showHamburger();
        }
    }

    showUserPreferences() {
        this.userPreferencesModalService.showModal();
    }

    /**
     * Attempts to logout the user, displaying the save plan prompt if required.
     * This implementation inspects the current route to see if it has an associated `canDeactivate` function.
     * To avoid having to manually inject parameters into that function in order to execute it here in this context, make the assumption that
     * `navigationService.canDeactivate` is the single implementation for Plan Portal used to determine whether a route can be navigated away from,
     * and invoke that implementation to determine whether the user can indeed logout, or more specifically for our use case, determine whether the
     * user should be displayed the save plan popup question before logging out.
     */
    logout() {
        if (!this.activatedRoute.routeConfig.canDeactivate) {
            this.authenticatorService.logout();
            this.authenticatorService.redirectToPF();
            return;
        }
        this.navigationService.canDeactivate().subscribe((proceed: boolean) => {
            if (!proceed) {
                return;
            }
            this.authenticatorService.logout();
            this.authenticatorService.redirectToPF();
            return;
        });
    }

    hasDesignPreferencesPermissions() {
        return this.permissionsService.hasPermission(this.editDesignPreferencesPermissions);
    }
}
